import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { AccordionAnimateBody } from './AccordionAnimateBody';
import { AccordionAnimateHeader } from './AccordionAnimateHeader';

const defaultProps = {
    isShow: false,
    isAnimate: true,
    onToggle: () => {
        return;
    },
};

const propTypes = {
    isShow: PropTypes.bool,
    isAnimate: PropTypes.bool,
    onToggle: PropTypes.func,
};

export class AccordionAnimate extends Component {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    constructor(props) {
        super(props);

        this.state = {
            isShow: this.props.isShow,
        };
    }

    getHeader(child) {
        return React.cloneElement(child, {
            isShow: this.state.isShow,
            onClick: this.accordionToggle,
        });
    }

    getBody(child) {
        return React.cloneElement(child, {
            duration: this.props.duration,
            isShow: this.state.isShow,
            isAnimate: this.props.isAnimate,
        });
    }

    accordionToggle = () => {
        this.setState(({ isShow }) => {
            return { isShow: !isShow };
        }, () => {
            this.props.onToggle(this.state.isShow);
        });
    }

    componentDidUpdate({ isShow }) {
        if (isShow !== this.props.isShow) {
            this.setState({
                isShow: this.props.isShow,
            });
        }
    }

    render() {
        return (
            <div className={this.props.className}>
                {React.Children.map(this.props.children, (child) => {
                    if (child.type && child.type.name === AccordionAnimateHeader.name) {
                        return this.getHeader(child);
                    } else if (child.type && child.type.name === AccordionAnimateBody.name) {
                        return this.getBody(child);
                    } else {
                        return child;
                    }
                })}
            </div>
        );
    }
}

export { AccordionAnimateBody } from './AccordionAnimateBody';
export { AccordionAnimateHeader } from './AccordionAnimateHeader';
